import {createContext,useContext} from "react";
const NotificationsContext=createContext();
export const useNotifications=()=>useContext(NotificationsContext);
export default NotificationsContext;